import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import { isNumber } from "../../utils/is.js";
export default {
  props: {
    visibleColumns: Array
  },
  computed: {
    colList: function colList() {
      if (this.columns !== void 0) {
        return this.columns;
      } // we infer columns from first row


      var row = this.data[0];
      return row !== void 0 ? Object.keys(row).map(function (name) {
        return {
          name: name,
          label: name.toUpperCase(),
          field: name,
          align: isNumber(row[name]) ? 'right' : 'left',
          sortable: true
        };
      }) : [];
    },
    computedCols: function computedCols() {
      var _this = this;

      var _this$computedPaginat = this.computedPagination,
          sortBy = _this$computedPaginat.sortBy,
          descending = _this$computedPaginat.descending;
      var cols = this.visibleColumns !== void 0 ? this.colList.filter(function (col) {
        return col.required === true || _this.visibleColumns.includes(col.name) === true;
      }) : this.colList;
      return cols.map(function (col) {
        var align = col.align || 'right';
        var alignClass = "text-".concat(align);
        return _objectSpread(_objectSpread({}, col), {}, {
          align: align,
          __iconClass: "q-table__sort-icon q-table__sort-icon--".concat(align),
          __thClass: alignClass + (col.headerClasses !== void 0 ? ' ' + col.headerClasses : '') + (col.sortable === true ? ' sortable' : '') + (col.name === sortBy ? " sorted ".concat(descending === true ? 'sort-desc' : '') : ''),
          __tdStyle: col.style !== void 0 ? typeof col.style !== 'function' ? function () {
            return col.style;
          } : col.style : function () {
            return null;
          },
          __tdClass: col.classes !== void 0 ? typeof col.classes !== 'function' ? function () {
            return alignClass + ' ' + col.classes;
          } : function (row) {
            return alignClass + ' ' + col.classes(row);
          } : function () {
            return alignClass;
          }
        });
      });
    },
    computedColsMap: function computedColsMap() {
      var names = {};
      this.computedCols.forEach(function (col) {
        names[col.name] = col;
      });
      return names;
    },
    computedColspan: function computedColspan() {
      return this.tableColspan !== void 0 ? this.tableColspan : this.computedCols.length + (this.hasSelectionMode === true ? 1 : 0);
    }
  }
};